import { api } from './api.ts'
import Config from '../helpers/Config'
import { AxiosResponse } from 'axios'
import { userActions } from '../stateManagment/features/userSlice.js'
import { identifyUser } from '../helpers/LogRocket'
import { logApiError } from '../helpers/TelemetryHelper'


// Define a service using a base URL and expected endpoints
export const authApi = api.injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation<AxiosResponse, any>({
            query: (credentials: any) => {
                const params = {
                    requestParameters: {
                        ...credentials
                    }
                }
                return {
                    url: Config.END_POINT_NAMES.GET_USER_LOGIN,
                    method: 'POST',
                    body: params,
                }
            },
            transformResponse: (response: any) => {
                const userData = response.data?.[0]
                if (userData.ResponseMsg !== "Login Successfully") {
                    throw new Error(userData.ResponseMsg)
                }
                return {
                    ...userData,
                    PayrollDeduction: userData.PayrollDeduction || {},
                    SizingTemplate : userData.SizingTemplate ||{},
                    RequiresEmailUpdate: userData?.RequiresEmailUpdate || false
                }
            },
            async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
                try {
                    const { data: userData } = await queryFulfilled;
                    dispatch(userActions.setUser(userData));
                    const state = getState() as any;
                    const ipHash = state.commonReducer?.lrClientIpHash;
                    void identifyUser(userData, null, ipHash).catch(() => {});
                } catch (error) { }
            },
        }),
        switchSession: build.mutation<AxiosResponse, any>({
            query: (credentials: any) => {
                const params = {
                    requestParameters: {
                        ...credentials
                    }
                }
                return {
                    url: Config.END_POINT_NAMES.SWITCH_SESSION,
                    method: 'POST',
                    body: params,
                }
            },
            transformResponse: (response: any) => {
                const userData = response.data?.[0]
                if (userData.ResponseMsg !== "Login Successfully") {
                    throw new Error(userData.ResponseMsg)
                }
                return {
                    ...userData,
                    PayrollDeduction: userData.PayrollDeduction || {},
                    SizingTemplate : userData.SizingTemplate ||{},
                    RequiresEmailUpdate: userData?.RequiresEmailUpdate || false
                }
            },
            async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
                try {
                    const { data: userData } = await queryFulfilled;
                    dispatch(userActions.setUser(userData));
                    const state = getState() as any;
                    const ipHash = state.commonReducer?.lrClientIpHash;
                    void identifyUser(userData, null, ipHash).catch(() => {});
                } catch (error) { }
            },
        }),        
        loginExt: build.query<AxiosResponse, any>({
            query: (credentials: any) => {
                return {
                    url: "slas/extauth?SP=" + credentials.externalSP + "&LoginSessionID=" + credentials.externalLoginSessionID + "&IsToggled=" + credentials.isToggled,
                    method: 'GET'
                }
            },
            transformResponse: (response: any) => {
                const userData = response.data?.[0]
                if (!userData || !userData.UserID) {
                    logApiError('LOGINEXT_TRANSFORM_NO_USERDATA', 'slas/extauth', {
                        hasResponseData: !!response.data,
                        responseDataLength: response.data?.length,
                        responseDataFirstItem: response.data?.[0] ? Object.keys(response.data[0]) : null,
                        responseStatusCode: response.statusCode,
                    })
                }
                return {
                    ...userData,
                    PayrollDeduction: userData?.PayrollDeduction || {},
                    SizingTemplate : userData?.SizingTemplate || {},
                    RequiresEmailUpdate: userData?.RequiresEmailUpdate || false
                }
            },
            async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
                try {
                    const { data: userData } = await queryFulfilled;
                    dispatch(userActions.setUser(userData));
                    const state = getState() as any;
                    const ipHash = state.commonReducer?.lrClientIpHash;
                    const loginSessionID = args.externalLoginSessionID;
                    void identifyUser(userData, loginSessionID, ipHash).catch(() => {});
                } catch (error: any) {
                    logApiError('LOGINEXT_ONQUERYSTARTED_ERROR', 'slas/extauth', {
                        errorMessage: error?.message ?? error?.error ?? String(error),
                        externalSP: args?.externalSP,
                        externalLoginSessionID: args?.externalLoginSessionID,
                    })
                }
            },
        }),
        refreshToken: build.mutation<AxiosResponse, any>({
            query: () => {
                return {
                    url: Config.END_POINT_NAMES.REFRESH_TOKEN,
                    method: 'POST',
                    body: {
                        requestParameters: {
                            placeHolder: '[]'
                        }
                    },
                }
            },
            transformResponse: (response: AxiosResponse) => {
                return response.data?.[0]
            }
        }),
        resetPassword: build.mutation<AxiosResponse, any>({
            query: (params) => {
                return {
                    url: Config.END_POINT_NAMES.VALIDATE_OTP_CHANGE_PASSWORD,
                    method: 'POST',
                    body: {
                        requestParameters: {
                            ...params
                        }
                    },
                }
            },
            transformResponse: (response: AxiosResponse) => {
                return response.data
            }
        }),
        sendResetOtp: build.mutation<AxiosResponse, any>({
            query: (params) => {
                return {
                    url: Config.END_POINT_NAMES.INIT_PASSWORD_RESET,
                    method: 'POST',
                    body: {
                        requestParameters: {
                            ...params
                        }
                    },
                }
            },
            transformResponse: (response: AxiosResponse) => {
                return response.data
            }
        }),
    })
})

export const { useLoginMutation, useLoginExtQuery, useRefreshTokenMutation, useSwitchSessionMutation, useResetPasswordMutation, useSendResetOtpMutation } = authApi
